import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalleFormula } from '../models/detalleformula';
import { Formula } from '../models/formula';
import { Sistemas } from '../models/roles';
import { Subformula } from '../models/subformula';
import { FormulaService } from '../services';

@Component({
  selector: 'app-detalle-formula',
  templateUrl: './detalle-formula.component.html',
  styleUrls: ['./detalle-formula.component.css']
})
export class DetalleFormulaComponent implements OnInit {


  formula: Formula;
  subformulas: Subformula[] ;
  idActual: string;
  idSistemaActual: number;


  cantidad: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formulaService: FormulaService,
    private location: Location
  ) { }

  ngOnInit(): void {
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.getFormulas();
  }

  getFormulas(): void {
    this.idActual = this.route.snapshot.paramMap.get('id');
    this.idSistemaActual = +this.route.snapshot.paramMap.get('idsistema');  

    this.formulaService.getFormulaById(this.idSistemaActual, this.idActual)
      .subscribe(form => {
        this.formula = form;

        this.subformulas = this.formula.subformulas
/* 
        if (form.subformulas.length) {
          this.subformulas = form.subformulas;
        } else {
          this.subformulas.push(form);
        }

 */

      });

  }

  get numberOfUnhandledHours() {
    return this.formula.detalle
      .reduce((sum: number, b: DetalleFormula) => sum + b.cantidad, 0);
  }

  iraFormula(formula: Formula) {
    this.router.navigate(['formula', 'sistema',formula.pk.idsistema, 'formula', formula.pk.id]), { relativeTo: this.route.parent }
  }

  goBack(): void {
    this.location.back();
  }

  downloadFile(): void {
  /*   const filename = 'prueba.pdf'
    this.formulaService
      .imprimirFormula(this.idActual)
      .subscribe(blob => saveAs(blob, filename)); */
  }


}
